/**
 * Hand-drawn-feel brand motifs (leaf + paw), used for dividers, markers,
 * and small accents. Kept dependency-free so they scale crisply anywhere.
 */

// Raw paw shapes (no <svg> wrapper) so they can be dropped inside any SVG <g>.
// Designed around a -5..5 box, centred on the origin.
export const PawShapes = ({ fill = "currentColor", ...rest }) => (
  <g fill={fill} {...rest}>
    <ellipse cx="0" cy="1.6" rx="2.5" ry="2.1" />
    <circle cx="-2.1" cy="-1.2" r="1.05" />
    <circle cx="-0.7" cy="-2.4" r="1.15" />
    <circle cx="0.7" cy="-2.4" r="1.15" />
    <circle cx="2.1" cy="-1.2" r="1.05" />
  </g>
);

export const Paw = ({ size = 18, className = "", fill = "currentColor" }) => (
  <svg width={size} height={size} viewBox="-5 -5 10 10" className={className} aria-hidden="true">
    <PawShapes fill={fill} />
  </svg>
);

export const LeafMark = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    aria-hidden="true"
  >
    <path d="M20.5 3.5C9.5 3.5 4 10.5 4 20.5c10 0 16.5-6 16.5-17z" fill="currentColor" opacity="0.16" />
    <path d="M20.5 3.5C9.5 3.5 4 10.5 4 20.5c10 0 16.5-6 16.5-17z" stroke="currentColor" strokeWidth="1.1" />
    <path d="M6 18.5C10 12.5 14.5 8.5 19 5.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

/** A centred divider with a leaf in the middle and thin rules either side. */
export const LeafDivider = ({ className = "", label }) => (
  <div className={`flex items-center justify-center gap-4 text-sage-500 ${className}`}>
    <span className="h-px bg-sage-200 flex-1 max-w-[110px]" />
    {label ? (
      <span className="flex items-center gap-2.5">
        <LeafMark size={16} />
        <span className="text-xs uppercase tracking-[0.22em] text-sage-600">{label}</span>
        <LeafMark size={16} className="-scale-x-100" />
      </span>
    ) : (
      <LeafMark size={18} />
    )}
    <span className="h-px bg-sage-200 flex-1 max-w-[110px]" />
  </div>
);
